<template>
  <div>
    <special-index v-show="special && special['index/index']" :page-path="'index/index'" :item-id="''"></special-index>

    <div class="container" v-show="!special || !special['index/index']">
      <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>

      <div class="user-nav disf">

        <div class="l">
          <div class="user disf">
            <div class="avatar cup">
              <img src="../../../assets/image/user.png" alt="user">
            </div>
            <div class="info">
              <div class="top">Hi,Welcome to Gobuy</div>
              <div class="username cup" v-if="user">
                {{ user ? user.member_name : $t('Login') }}
              </div>
              <div class="username cup login" @click="onPage('HomeMemberLogin')" v-else>
                {{ $t('Login') }}
              </div>
            </div>
          </div>
        </div>

        <div class="c">
          <div class="gift cup banner-container">
              <div class="slick-slider" ref="slick">
                <div>
                  <img src="../../../assets/image/home/gobuy.png" @click="onPage('HomeGoBuy')" alt="gobuy" />
                </div>
                <!-- <div>
                  <img src="../../../assets/image/im.png" @click="gotoIm" alt="gotoIm" />
                </div> -->
              </div>
          </div>
        </div>
        
        <div class="r">
          <div class="menus disf">
            <div class="menu cup" v-for="(item, index) in menuList" :key="index">
              <div class="icon" @click="onPage(item.name)">
                <img :src="item.icon" alt="icon">
              </div>
              <div class="name">{{ $t(item.lang) }}</div>
            </div>
          </div>
        </div>
      </div>

      <CategoryCarousel v-if="class_list.length > 0" :data="class_list" />

      <div class="hot">
        <div class="tit disf">
          <div class="icon">
            <img src="../../../assets/image/hot.png" alt="hot">
          </div>
          <div class="text">HOT SALE</div>
        </div>

        <div class="list">
          <index-product-list :items="list" :type="popular" v-if="list && list.length > 0"></index-product-list>
        </div>
      </div>

    </div>

    <audio src="../../../assets/image/gobuy/44s.mp3" muted style="display: none;"></audio>
    <audio src="../../../assets/image/gobuy/15s.mp3" muted style="display: none;"></audio>
  </div>
</template>

<script>
import { Goodsclass, goods_index_list} from '../../../api/homeindex'
import { getAddressInfo } from '../../../api/memberBuy'
import IndexBanner from './IndexBanner'
import store from '../../../store'
import { mapState, mapActions } from 'vuex'
import { Toast,MessageBox } from 'mint-ui'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import CategoryCarousel from './CategoryCarousel'

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';

export default {
  name: 'HomeIndex',
  data() {
    return {
      isshowBacktop: true,
      popular: '',
      sale: 'goods_salenum',
      recently: 'goods_addtime',
      tabs: [
        {
          gc_name: 'TodaysOffer'
        }
      ],
      activeTab: 0,
      list: [],
      chartInstance: null,
      slots: [
        {
          values: []
        }
      ],
      popupVisible: false,
      class_list: [],
      address_info: null,
      menuList: [
        {
          name: 'MemberCommission',
          icon: require('../../../assets/image/MyCommission.png'),
          lang: 'MyCommission'
        },
        {
          name: 'GiftBoxList',
          icon: require('../../../assets/image/GiftCardList.png'),
          lang: 'GiftCard'
        },
        {
          name: 'MemberOrderList',
          icon: require('../../../assets/image/MyOrders.png'),
          lang: 'MyOrders'
        },
      ]
    }
  },
  components: {
    IndexBanner,
    SpecialIndex,
    IndexProductList,
    CategoryCarousel
  },
  mounted() {
    $(this.$refs.slick).slick({
      color: '#EF4618',
      arrows: true, // 显示左右箭头
      autoplay: true, // 自动播放
      autoplaySpeed: 3000, // 自动播放速度
    });
    getAddressInfo().then(res => {
      if (res.code == 10000) {
        this.address_info = res.result
      }
    })
    Goodsclass().then(res => {
      this.class_list = res.result
      this.getList()
    })
  },
  created: function () {
    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    // this.fetchHomeProduct({}).then(
    //   response => {
    //   },
    //   error => {
    //     Toast(error.message)
    //   }
    // )
    this.fetchConfig({}).then(
      (res) => {
        if (res.result.config_list.home_status == 1) {
          MessageBox({
            title: this.$t('MessageBox.Tips'),
            message: res.result.config_list.home_content,
            confirmButtonText: 'Apply to join',
            showCancelButton: false,
            closeOnClickModal: true,   // 点击任意区域关闭
            closeOnPressEscape: true  // 按 ESC 关闭（PC）
          }).then(action => {
            // 点击“确认”按钮后跳转
            if (action === 'confirm') {
              window.location.href = res.result.config_list.whatsapp_url;
            }
          }).catch(() => {
            // 点击遮罩关闭，不做任何事
          })
        }
      },
      (error) => {
        Toast(error.message)
      }
    );
  },
  computed: {
    ...mapState({
      user: state => state.member.info,
      special: state => state.home.special,
      config: state => state.config.config,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      promotionAds: state => state.home.promotionAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts,
      banners: state => state.home.banners,
    })
  },
  methods: {
    prevSlide() {
      this.$refs.swipe.swipeTo(this.$refs.swipe.index - 1);
    },
    nextSlide() {
      this.$refs.swipe.swipeTo(this.$refs.swipe.index + 1);
    },
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      // fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    }),
    getEmail() {
      this.$router.push({ name: 'MemberContactUs' })
    },
    tabClick(item, index) {
      this.activeTab = index

      this.getList(item.id)
    },
    getList(id) {
      goods_index_list(id).then(res => {
        this.list = res.result.goods_list
      })
    },
    onPage(path) {
      this.$router.push({ name: path })
    },
    gotoIm() {
      window.location.href = '/im/?token='+store.state.member.token
    }
  }
}
</script>

<style>
.mint-msgbox {
  width: 46% !important;
  white-space: pre-line;
}
.mint-msgbox-message{text-align: left;line-height:22px;}
.banner-container {
  width: 100%;
  height: 4.1rem;
}
.slick-slider img {
  width: 100%;
  height: auto;
}
.slick-prev:before, .slick-next:before {
  color:#ef4517 !important;
}
</style>
<style scoped lang="scss">
.hot {
  width: 1200px;
  padding: 12px;
  margin: 19px 0 23px;
  box-sizing: border-box;
  background: linear-gradient(-45deg, #FFAA5F 0%, #EF4618 100%);
  border-radius: 10px;

  .tit {
    justify-content: flex-start;

    .icon {
      width: 68px;
      height: 34px;
    }

    .text {
      font-size: 24px;
      color: #FFFFFF;
      margin-left: 5px;
    }
  }

  .list {
    padding: 10px;
    border-radius: 10px;
    background: #FFFFFF;
    margin-top: 13px;
    min-height: 244px;
  }
}

.user-nav {
  margin: 21px 0;
  padding: 10px 22px;
  box-sizing: border-box;
  width: 1200px;
  height: 123px;
  background: linear-gradient(270deg, #FFF1DE 0%, #FFFFFF 99%);
  border-radius: 6px;

  .user {
    .avatar {
      width: 76px;
      height: 76px;
    }
  }

  .info {
    margin-left: 20px;

    .top {
      font-size: 16px;
      color: #333333;
    }

    .username {
      height: 30px;
      box-sizing: border-box;
      display: inline-block;
      margin: 14px 0 0;
      padding: 6px 15px;
      background: #FFFFFF;
      border-radius: 15px;
      border: 1px solid #EF4618;
      font-size: 14px;
      color: #EF4618;
    }

    .login {
      color: #FFFFFF;
      background: #EF4618;
    }
  }

  .gift {
    width: 413px;
    height: 95px;
  }

  .menus {
    .menu {
      margin-left: 35px;

      .icon {
        width: 76px;
        height: 76px;
        margin: 0 auto;
      }

      .name {
        text-align: center;
        margin-top: 10px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}

.container {
  padding-bottom: 1px;
}

.tabs {
  padding-left: .7rem;
  padding-right: .7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 .5rem;
  height: 1.5rem;
  background: #fff;
  margin: 2rem 0;

  .tab {
    // flex: 1;
    text-align: center;
    font-size: $fontSize;
    color: #333;
    padding: 7px 16px;
  }

  .active { 
    display: inline-block;
    font-size: 28px;
    font-weight: 700;
    padding: 0 50px;
  }
}

.banner_ {
  margin: 0 10px 30px;

  img {
    width: 100%;
    height: 100%;
  }
}

.lang {
  top: 5px;
  right: 5px;
  z-index: 99;

  img {
    width: 1.5rem;
  }
}

.picker-toolbar-title {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background: #f5f5f5;
}

.usi-btn-cancel,
.usi-btn-sure {
  color: #108ee9;
}

::v-deep .product-list-header {

  .slot {
    width: 4.5rem !important;
  }
}

::v-deep .picker {
  .picker-items {
    width: 100%;
  }

  .picker-slot {
    flex: 1;
  }
}

.banner {

  img {
    width: 100%;
    height: 100%;
  }
}

img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
